import * as React from "react";
const SvgArrowLineLeft20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      d: "M17 9v2H6.828l2.423 2.422-1.414 1.415L3 10l4.837-4.837L9.25 6.578 6.828 9H17Z"
    })
  );
export default SvgArrowLineLeft20Px;
